import type { Dapp } from '@src/dto';
import { PUBLISHER_FROZEN_NEW_VERSION_MESSAGE } from './publisherFreeze';

export const APP_NFT_REQUIRED_MESSAGE =
  'You must mint an App NFT before creating a new version.';

export const RELEASE_MANAGEMENT_PERMISSION_MESSAGE =
  'Your publisher role does not include release management. Ask a publisher owner or admin to create a new version.';

const STORE_SUBMISSION_PERMISSION_MESSAGE =
  'Your publisher role does not include store submission. Ask a publisher owner or admin to publish this version.';

export const NEW_VERSION_PERMISSION_MESSAGE =
  RELEASE_MANAGEMENT_PERMISSION_MESSAGE;

export function getReleaseManagementPermissionMessage(
  dapp?: Pick<Dapp, 'canManageReleases'> | null,
): string | undefined {
  return dapp?.canManageReleases === false
    ? RELEASE_MANAGEMENT_PERMISSION_MESSAGE
    : undefined;
}

export function getStoreSubmissionPermissionMessage(
  dapp?: Pick<Dapp, 'canSubmitToStore'> | null,
): string | undefined {
  return dapp?.canSubmitToStore === false
    ? STORE_SUBMISSION_PERMISSION_MESSAGE
    : undefined;
}

export function getNewVersionPermissionMessage(
  dapp?: Pick<Dapp, 'canManageReleases'> | null,
): string | undefined {
  return getReleaseManagementPermissionMessage(dapp);
}

export function getNewVersionBlockedMessage(
  dapp?: Pick<
    Dapp,
    | 'canManageReleases'
    | 'canSubmitToStore'
    | 'hasApprovedRelease'
    | 'lastApprovedReleaseId'
    | 'nftMintAddress'
    | 'publisherFrozen'
  > | null,
): string | undefined {
  if (!dapp) {
    return undefined;
  }

  if (dapp.publisherFrozen) {
    return PUBLISHER_FROZEN_NEW_VERSION_MESSAGE;
  }

  if (!dapp.nftMintAddress) {
    return APP_NFT_REQUIRED_MESSAGE;
  }

  return getNewVersionPermissionMessage(dapp);
}
